import { ReactNode } from 'react';
import { useSubscription, SubscriptionTier } from '@/hooks/useSubscription';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';

interface SubscriptionGateProps {
  requiredTier: SubscriptionTier;
  children: ReactNode;
  fallback?: ReactNode;
}

export const SubscriptionGate = ({ requiredTier, children, fallback }: SubscriptionGateProps) => {
  const { hasAccess } = useSubscription();
  const navigate = useNavigate();

  if (hasAccess(requiredTier)) {
    return <>{children}</>;
  }

  if (fallback) {
    return <>{fallback}</>;
  }

  const tierLabels: Record<SubscriptionTier, string> = {
    none: "No Plan",
    starter: "Automation Starter",
    growth: "Growth Plan",
    enterprise: "Enterprise / Elite"
  };

  return (
    <div className="relative">
      <div className="blur-sm pointer-events-none select-none">
        {children}
      </div>
      <div className="absolute inset-0 bg-background/90 backdrop-blur-sm flex items-center justify-center p-6">
        <div className="text-center max-w-sm space-y-3">
          <div className="flex justify-center mb-2">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
              <Lock className="w-6 h-6 text-primary" />
            </div>
          </div>
          <h3 className="font-semibold text-foreground">Locked Feature</h3>
          <p className="text-sm text-muted-foreground">
            This tool is available for <strong>{tierLabels[requiredTier]} customers</strong>.
          </p>
          <Button
            onClick={() => navigate('/ai-automation')}
            size="sm"
          >
            Upgrade Plan
          </Button>
        </div>
      </div>
    </div>
  );
};
